export const buttonColor = {
  disabled: {
    background: '#EAEAEA',
    border: '1px solid #C4C4C4',
    color: '#C4C4C4',
  },
  '#428BCA': {
    background: '#428BCA',
    border: '1px solid #428BCA',
    color: '#FFFFFF',
    outline: {
      background: 'transparent',
      border: '1px solid #428BCA',
      color: '#428BCA',
      hover: {
        background: '#428BCA',
        border: '1px solid #428BCA',
        color: '#FFFFFF',
      },
    },
    hover: {
      background: '#333333',
      border: '1px solid #CCCCCC',
      color: '#FFFFFF',
    },
  },
  '#D44B49': {
    background: '#D44B49',
    border: '1px solid #D44B49',
    color: '#FFFFFF',
    outline: {
      background: 'transparent',
      border: '1px solid #D44B49',
      color: '#D44B49',
      hover: {
        background: '#D44B49',
        border: '1px solid #D44B49',
        color: '#FFFFFF',
      },
    },
    hover: {
      background: '#c82333',
      border: '1px solid #bd2130',
      color: '#FFFFFF',
    },
  },
  '#28a745': {
    background: '#28a745',
    border: '1px solid #28a745',
    color: '#FFFFFF',
    outline: {
      background: 'transparent',
      border: '1px solid #28a745',
      color: '#28a745',
      hover: {
        background: '#28a745',
        border: '1px solid #28a745',
        color: '#FFFFFF',
      },
    },
    hover: {
      background: '#218838',
      border: '1px solid #218838',
      color: '#FFFFFF',
    },
  },
  '#6c757d': {
    background: '#6c757d',
    border: '1px solid #6c757d',
    color: '#FFFFFF',
    hover: {
      background: '#5a6268',
      border: '1px solid #5a6268',
      color: '#FFFFFF',
    },
  },
  '#F0C34E': {
    background: '#F0C34E',
    border: '1px solid #E6AC1A',
    color: '#1A1A17',
    hover: {
      background: '#DFAC2A',
      border: '1px solid #DFAC2A',
      color: '#1A1A17',
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/buttons/color.js